module.exports = __webpack_public_path__ + "static/media/1.b7eae4c5.png";